import { styled } from "@mui/system";
import { Typography, Box } from "@mui/material";

const AboutContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  [[theme.breakpoints.between("xs", "sm")]]: {
    marginBottom: theme.spacing(2),
  },
  [[theme.breakpoints.between("sm", "md")]]: {
    marginBottom: theme.spacing(4),
  },
  [[theme.breakpoints.between("md", "lg")]]: {
    marginBottom: theme.spacing(4),
  },
  [theme.breakpoints.up("lg")]: {
    marginBottom: theme.spacing(4),
  },
}));

const StyledCaption = styled(Typography)(({ theme }) => ({
  textAlign: "center",
  variant: "caption",
  component: "span",
  color: "#424343",
  font: "normal normal 400 16px open sans",

  [[theme.breakpoints.between("xs", "sm")]]: {
    font: "normal normal 400 8px open sans",
    marginTop: theme.spacing(2),
  },
  [[theme.breakpoints.between("sm", "md")]]: {
    font: "normal normal 400 12px open sans",
    marginTop: theme.spacing(4),
  },
  [[theme.breakpoints.between("md", "lg")]]: {
    font: "normal normal 400 16px open sans",
    marginTop: theme.spacing(6),
  },
  [theme.breakpoints.up("lg")]: {
    font: "normal normal 400 20px open sans",
    marginTop: theme.spacing(8),
  },
}));

const AboutSection = () => {
  return (
    <AboutContainer>
      <StyledCaption>
        Copyright© 2023 OmFinServ | Axis. All Rights Reserved |{" "}
        <a href="https://shorturl.at/kxXY3" target="_blank" rel="noreferrer">
          Privacy Policy
        </a>
      </StyledCaption>
    </AboutContainer>
  );
};

export default AboutSection;
